import AsyncStorage from "@react-native-async-storage/async-storage";

export const storeLoginData = async (value) => {
  try {
    const jsonValue = JSON.stringify(value);
    await AsyncStorage.setItem("@loginData", jsonValue);
  } catch (e) {
    // saving error
  }
};

export const getLoginData = async () => {
  try {
    const jsonValue = await AsyncStorage.getItem("@loginData");
    let data = JSON.parse(jsonValue);

    return data;
  } catch (e) {}
};
export const getLocationDetails = async () => {
  // CACHING DISABLED - Always return null
  return null;
};
export const storeEventId = async (value) => {
  // CACHING DISABLED - No longer storing event ID in AsyncStorage
  console.log('storeEventId called but caching is disabled');
  return;
};

export const getEventId = async () => {
  // CACHING DISABLED - Always return empty string
  return "";
};

export const removeEventId = () => {
  AsyncStorage.removeItem("@eventID");
};

export const removeLoginData = () => {
  AsyncStorage.removeItem("@loginData");
};

export const storeUserBio = async (value) => {
  // CACHING DISABLED - No longer storing user bio in AsyncStorage
  console.log('storeUserBio called but caching is disabled');
  return;
};

export const getUserBio = async () => {
  // CACHING DISABLED - Always return empty string
  return "";
};

export const removeUserBio = () => {
  AsyncStorage.removeItem("@userBio");
};

export const storeSessionId = async (value) => {
  // CACHING DISABLED - No longer storing session ID in AsyncStorage
  console.log('storeSessionId called but caching is disabled');
  return;
};

export const getSessionId = async () => {
  // CACHING DISABLED - Always return empty string
  return "";
};

export const removeSessionId = () => {
  AsyncStorage.removeItem("@sessionID");
};
